import {
    Box,
    Button,
    Grid,
    FormControl,
    Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import SelectableSearch from "../../../Base/views/SelectableSearch";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { PlansAction } from "../../../../../store/Plans/Action";
import { UpdateSubscriptionAction } from "../../../../../store/Ancillary/Subscribe/Action";
const ChoosePlanPopup = ({
    setOpenPopup,
    subscriptionData
}) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const initialValue = { due_date: "", group_org_boolean: false, face_recog_boolean: false, planid: "" };
    const [formData, setFormData] = useState(initialValue);
    const { plansdata } = useSelector((state) => state?.PlansReducer);
    const [plansData, setplansData] = useState({ load: true, values: [] });
    const [errors, setErrors] = useState({});
    const [expiryDays, setExpiryDays] = useState(0);
    useEffect(() => {
        dispatch(PlansAction());
        setFormData({
            ...subscriptionData,
            planid: subscriptionData?.plan_id
                ? {
                    planid: subscriptionData?.plan_id,
                    planname: subscriptionData?.plan_name,
                }
                : "",
        })
        setExpiryDays(subscriptionData?.expiry_days)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSubmit = () => {
        if (validate(formData)) {
            dispatch(UpdateSubscriptionAction({
                due_date: formData?.due_date,
                planid: formData?.planid?.planid,
                group_org_boolean: formData?.group_org_boolean,
                face_recog_boolean: formData?.face_recog_boolean,
                access_payroll:  formData?.planid?.planname === "Premium" ? true : false
            }));
            setOpenPopup(false);
            setFormData(initialValue);
            setExpiryDays(0);
        }
    };
    const handleInputChange = (event, value) => {
        if (["group_org_boolean", "face_recog_boolean"].includes(event?.target?.name)) {
            setFormData({
                ...formData,
                [event.target.name]: event.target.checked,
            });
        }
        else if (["planid"].includes(event)) {
            if (value) {
                setFormData({ ...formData, [event]: value });
            } else {
                setFormData({ ...formData, [event]: "" });
            }
        }
        else {
            setFormData({
                ...formData,
                [event.target.name]: event.target.value,
            });
        }
    };
    const validate = (fieldValues) => {
        let temp = { ...errors };
        if ("due_date" in fieldValues) {
            temp.due_date =
                fieldValues.due_date === "" ? "Expiry Date is required" : "";
        }
        if ("planid" in fieldValues) {
            temp.planid =
                fieldValues.planid === "" ? "Plan is required" : "";
        }
        setErrors({
            ...temp,
        });
        return Object.values(temp).every((x) => x === "");
    };
    return (
        <Box sx={{ minWidth: "300px" }}>
            <Grid container sx={{ flexGrow: 1 }}>
                <Grid item xs={12} md={12} p={1}>
                    <FormControl fullWidth>
                        <CommonDatePicker
                            size="small"
                            name="due_date"
                            label="Expiry Date"
                            pickerType="date"
                            onKeyPress={(e) => e.preventDefault()}
                            onKeyDown={(e) => e.preventDefault()}
                            pickerFormat="dd/MM/yyyy"
                            DefaultDTvalue={formData?.due_date}
                            required
                            minDate={new Date()}
                            handleChange={(value) => {
                                const selectedDate = value;
                                const currentDate = new Date();
                                const timeDifference = selectedDate - currentDate;
                                const daysDifference = Math.ceil(
                                    timeDifference / (1000 * 60 * 60 * 24)
                                );
                                setExpiryDays(daysDifference);
                                handleInputChange({
                                    target: {
                                        name: "due_date",
                                        value: value
                                            ? `${value?.getFullYear() +
                                            "-" +
                                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                                            "-" +
                                            ("0" + value?.getDate()).slice(-2)
                                            }`
                                            : "",
                                    },
                                });
                            }}
                            {...(errors.due_date && {
                                error: true,
                                helperText: errors.due_date,
                            })}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ pt: 2 }}>
                        <SelectableSearch
                            isOptionEqualToValue={(option, value) =>
                                +option.planid === +value.planid
                            }
                            filterOptions="planid"
                            keys={["planid", "planname"]}
                            label="Plans"
                            required
                            value={formData?.planid}
                            loading={() =>
                                setplansData({ load: false, values: plansdata || [] })
                            }
                            fieldLabel="planname"
                            variant={"contained"}
                            name="planid"
                            size="small"
                            data={plansData}
                            onChangeEvent={handleInputChange}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                    {...props}
                                >
                                    {option.planname} - &#8377; {option.plancost}
                                </Box>
                            )}
                            {...(errors.planid && {
                                error: true,
                                helperText: errors.planid,
                            })}

                        />
                    </FormControl>
                    {/* <FormControlLabel
                                control={
                                    <Checkbox
                                        name="group_org_boolean"
                                        checked={formData?.group_org_boolean || false}
                                        onChange={handleInputChange}
                                    />
                                }
                                label="Enable Group Organisation flow?"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="face_recog_boolean"
                                        checked={formData?.face_recog_boolean || false}
                                        onChange={handleInputChange}
                                    />
                                }
                                label="Enable Face Recognition?"
                            /> */}
                </Grid>
            </Grid>
            <Grid
                container
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: "sticky",
                    bottom: -20,
                    zIndex: 1,
                    backgroundColor: "#ffffff",
                    p: 1,
                }}
            >
                <Typography
                    variant="p"
                    sx={{
                        marginRight: 2,
                        fontSize: "13px",
                        color: theme?.palette?.primary?.main,
                    }}
                >
                    Expiry Days : {expiryDays} Days
                </Typography>
                <Button size="small" onClick={handleSubmit} variant="outlined">
                    Submit
                </Button>
            </Grid>

        </Box>

    );
};

export default ChoosePlanPopup;
